import 'css-chunk:src/feature/modifier/ModifierCardButton.module.scss';export default {
  "root": "ModifierCardButton_root",
  "is_selected": "ModifierCardButton_is_selected",
  "btn_main": "ModifierCardButton_btn_main",
  "show_btn_quantity": "ModifierCardButton_show_btn_quantity",
  "btn_quantity": "ModifierCardButton_btn_quantity",
  "btn_quantity_wrapper": "ModifierCardButton_btn_quantity_wrapper",
  "is_disabled": "ModifierCardButton_is_disabled",
  "hide_icon_check": "ModifierCardButton_hide_icon_check",
  "icon_check": "ModifierCardButton_icon_check",
  "hide_icon_error": "ModifierCardButton_hide_icon_error",
  "icon_error": "ModifierCardButton_icon_error",
  "hide_icon_next": "ModifierCardButton_hide_icon_next",
  "icon_next": "ModifierCardButton_icon_next",
  "hide_command": "ModifierCardButton_hide_command",
  "command": "ModifierCardButton_command",
  "hide_price_diff": "ModifierCardButton_hide_price_diff",
  "price_diff": "ModifierCardButton_price_diff",
  "hide_quantity_count": "ModifierCardButton_hide_quantity_count",
  "quantity_count": "ModifierCardButton_quantity_count",
  "pulse": "ModifierCardButton_pulse",
  "name": "ModifierCardButton_name"
};